import { t } from 'javascripts/utils/withTranslation';

export default function addOverlayLink($link, disableMouseEvents = false) {
  const $target = $link.closest(
    `.${$link.getAttribute('data-overlay-target')}`
  );

  if (!$target) {
    return;
  }

  // save alt tags on images as they could be altered on mouseover
  const $imagesInsideTarget = $target.querySelectorAll('img');
  $imagesInsideTarget.forEach(($image) => {
    $image.setAttribute('data-alt', $image.getAttribute('alt'));
  });

  if (!disableMouseEvents) {
    $link.addEventListener('click', (event) => {
      if (event.button === 2 || event.button === 1) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  $target.addEventListener('mouseover', () => {
    $target.classList.add('active-overlay');
    $target.style.cursor = 'pointer';

    // if image inside target is hovered, add the link target to the alt text
    if ($imagesInsideTarget) {
      $imagesInsideTarget.forEach(($image) => {
        const alt = $image.getAttribute('data-alt');
        const isDecorative = alt === '' || alt === null || alt === ' ';
        if (!isDecorative) {
          $image.setAttribute(
            'alt',
            `${$image.getAttribute('data-alt') || ''}, ${t('Link')} ${
              $link.innerText
            }`
          );
        }
      });
    }
  });

  $target.addEventListener('mouseout', () => {
    $target.classList.remove('active-overlay');
    $target.removeAttribute('style');
  });

  $target.addEventListener('focusin', (event) => {
    if (event.target === $link) {
      $target.classList.add('active-focus-overlay');
    }
  });

  $target.addEventListener('focusout', () => {
    $target.classList.remove('active-focus-overlay');
  });

  // Open link in new tab if middle mouse button is clicked or imitate a normal click
  $target.addEventListener('mouseup', (event) => {
    const anotherLinkClicked = event.target.closest(
      'a, button, .copyright--interactive'
    );
    // right click (on windows) or clicking another link should not open the link
    if (
      event.button === 2 ||
      (anotherLinkClicked && anotherLinkClicked !== $link)
    ) {
      return;
    }
    if (disableMouseEvents) {
      event.stopPropagation();
      $link.click();
      return;
    }
    if (event.button === 1 || $link.target === '_blank') {
      window.open($link.href, '_blank');
    } else {
      window.location.href = $link.href;
    }
  });
}

document.querySelectorAll('.js-overlay-link').forEach(($link) => {
  addOverlayLink($link);
});
